module.exports = __webpack_public_path__ + "static/media/gray_06.20263493.jpg";